module.exports = __webpack_public_path__ + "static/media/thinking.8923d8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thinking.png
// module id = 1486
// module chunks = 0